import {
  Skeleton,
  TextSkeleton,
} from '../../../../../packages/ui/components/skeleton';

export const WebCoinSkeleton = () => {
  return (
    <div>
      <div className="no-scrollbar grid w-auto grid-flow-col flex-row flex-nowrap justify-stretch gap-[10px] overflow-auto p-5 text-xs md:justify-start">
        <Skeleton className="h-8 w-[140px]" />
        <Skeleton className="w-[140px]" />
        <Skeleton className="w-[140px]" />
        <Skeleton className="w-[140px]" />
      </div>
      <Skeleton className="h-[90px] w-full" />
      <div className="mt-6">
        <TextSkeleton lineHeight={24} fontSize={16} className="w-20" />
        <TextSkeleton lineHeight={18} fontSize={12} className="mb-8" />
        <div className="flex flex-col gap-4">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      </div>
    </div>
  );
};
